import { Bar, BarChart, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { shortDay } from "@/lib/nutri";

const Avg = ({ label, value, unit, testid }) => (
  <div className="border-l border-[rgba(152,191,162,0.2)] pl-4">
    <p className="font-mono text-[11px] uppercase tracking-widest text-[#a3b1aa]">{label}</p>
    <p data-testid={testid} className="font-display text-3xl font-900">{Math.round(value || 0)}<span className="text-base text-[#a3b1aa]"> {unit}</span></p>
  </div>
);

export const WeekSummary = ({ week }) => {
  const days = (week?.days || []).map((d) => ({ ...d, label: shortDay(d.date) }));
  const goal = week?.goals?.kcal ?? 2000;
  const avg = week?.average || {};
  const logged = days.filter((d) => d.kcal > 0).length;
  const waterAvg = days.length ? days.reduce((s, d) => s + d.water_ml, 0) / days.length : 0;

  return (
    <section data-testid="week-summary" className="mt-6 border border-[rgba(152,191,162,0.15)] bg-[#0b120e] p-6 md:p-8">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <div>
          <p className="eyebrow">Riepilogo settimana</p>
          <h2 className="mt-1 font-display text-4xl font-900 uppercase">Ultimi 7 giorni</h2>
        </div>
        <p data-testid="week-logged-days" className="font-mono text-xs text-[#a3b1aa]">{logged}/7 giorni registrati</p>
      </div>
      <div className="h-56 w-full">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={days} margin={{ left: -20, right: 0, top: 10 }}>
            <XAxis dataKey="label" tick={{ fill: "#a3b1aa", fontSize: 12, fontFamily: "JetBrains Mono" }} axisLine={false} tickLine={false} />
            <YAxis domain={[0, (max) => Math.max(goal, max) * 1.1]} tickFormatter={(v) => Math.round(v)} tick={{ fill: "#a3b1aa", fontSize: 11 }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "rgba(152,191,162,0.08)" }} contentStyle={{ background: "#050807", border: "1px solid rgba(152,191,162,.3)", color: "#f4f7f5" }}
              formatter={(v) => [`${Math.round(v)} kcal`, "Calorie"]} labelFormatter={(l) => l} />
            <ReferenceLine y={goal} stroke="#c4dcca" strokeDasharray="4 4" />
            <Bar dataKey="kcal" fill="#98bfa2" radius={[2, 2, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
      <div className="mt-6 grid grid-cols-2 gap-5 md:grid-cols-5">
        <Avg label="Media kcal" value={avg.kcal} unit="kcal" testid="avg-kcal" />
        <Avg label="Proteine" value={avg.protein} unit="g" testid="avg-protein" />
        <Avg label="Carboidrati" value={avg.carbs} unit="g" testid="avg-carbs" />
        <Avg label="Grassi" value={avg.fat} unit="g" testid="avg-fat" />
        <Avg label="Acqua media" value={waterAvg} unit="ml" testid="avg-water" />
      </div>
    </section>
  );
};
